import {LoginAlertConstant} from "../actionTypes/login.alert.constant";

const InitialState = {
    status : false,
    auth : null,
    isFetching : false,
    loginStatus : false,
    csrfToken : null,
    username :null,
    deployment_mode: 'cloud',
    isWrongCredential : false,
    isServerUnreachable : false,
    is_staff: false,
    superuser: false
}

export const loginAlerts = ( state = InitialState , action) => {
    switch(action.type){
        case LoginAlertConstant.LOGIN_REQUEST :
            return{
                ...state,
                isFetching : true
            }
        case LoginAlertConstant.LOGIN_SUCCESS :
            return{
                isFetching : false,
                loginStatus : true,
                authToken : action.response.data.token,
                status : true,
                username : Object.assign("", action.response.data.user.first_name),
                user_id : action.response.data.user.id,
                superuser : action.response.data.user.is_superuser,
                is_staff : action.response.data.user.is_staff,
                deployment_mode: action.response.data.deployment_mode,
                isWrongCredential : false,
                isServerUnreachable : true
            }
        case LoginAlertConstant.LOGIN_ERROR :
            console.log(action.response.status);
            return{
                ...state,
                isWrongCredential : action.response.status == 504 ? false : true,
                isServerUnreachable : action.response.status == 504 ? true : false,
                isFetching : false,
            }
        case LoginAlertConstant.LOGOUT :
            return{
                auth : null,
                isFetching : false,
                loginStatus : false,
                csrfToken : null,
                authToken : null,
                status : false,
                isWrongCredential : false,
                isServerUnreachable : true
            }
        case LoginAlertConstant.CSRF_TOKEN_SUCCESS :
            return{
                ...state,
                csrfToken : action.response,
            }
        default :
            return state
    }
}